import { SALES_RETURN_REGISTER_REPORT_FAILURE, SALES_RETURN_REGISTER_REPORT_REQUEST, SALES_RETURN_REGISTER_REPORT_SUCCESS } from "../types";
  
  const initialState = {
    salesReturnRegisterReport: {},
    loading: false,
    error: null,
  };
  
  const salesReturnReportReducer = (state = initialState, action) => {
    switch (action.type) {
      case SALES_RETURN_REGISTER_REPORT_REQUEST: {
        return {
          ...state,
          loading: true,
          error: null
        };
      }
      case SALES_RETURN_REGISTER_REPORT_SUCCESS: {
        console.log("Sales Return Payload",action.payload);
        
        return {
          ...state,
          salesReturnRegisterReport: {...(action.payload || {})},
          loading: false,
          error: null
        };
      }
      case SALES_RETURN_REGISTER_REPORT_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        };
      }
      default:
        return state;
    }
  };
  
  export default salesReturnReportReducer;
  